import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";



function PJMediaOrderStart(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className="col-sm-10 offset-sm-1 col-xs-12 offset-xs-0 order-start step-1 box-shadow-bottom">
            <p className={'center subhead'}>You've picked</p>
            <h1 className={'center'} dangerouslySetInnerHTML={{__html: data.title}} />
            <p className={'center'}>What's included:</p>
            <div className={'col-sm-6 offset-sm-3 col-xs-12 highlights'}>
                <div className="container">
                    {data.included.map((included, i) => {
                        return (
                            <div className="row">
                                <div className="col-sm-6  offset-sm-0 col-xs-5 offset-xs-1">
                                    <div>
                                        <div className="included" key={i}>
                                            <div key={i} className="bundle-product name" dangerouslySetInnerHTML={{__html: included.title}} />
                                            <div key={i} className="bundle-product subheading" dangerouslySetInnerHTML={{__html: included.subheading}} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6  offset-sm-0 col-xs-5 offset-xs-0">
                                    <div>
                                        <div className="included" key={i}>
                                            <div key={i} className="bundle-product highlight" dangerouslySetInnerHTML={{__html: included.highlight}} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <hr className="has-light-gray-color" />

                <p className={"bundle-price center"}>${data.price}</p>

                <hr className="line-item mx-auto has-light-gray-color mb-0" />
                <div className="has-light-grey-background-color">
                    <p className="center p-1 has-grey-color">Pay just 20% upfront now to confirm your order.</p>
                </div>
                <div className="line-item ml-auto monthly-total order-total d-flex">
                    <div className="title flex-fill mt-auto">Upfront cost</div>
                    <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(data.price * 0.2)}} />
                </div>
            </div>

        </div>
    );
}

export { PJMediaOrderStart };